// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"oh4ufEFGa57TMUljoZDd"};